import { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import { BiTimer } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { redirectToMerchant } from '../../utils/paymentVisitStorage';

const AUTO_REDIRECT_DELAY_MS = 120 * 1000;

export default function TransactionExpiredModal({ show = false }) {

  const { token } = useParams();
  const { isShowTransactionExpiredModal, cancelUrl } = useSelector(state => state.main);

  let _cancelUrl = cancelUrl || localStorage.getItem("cancelUrl") || null;

  const redirectToCancelUrl = () => {
    if (!_cancelUrl) {
      return false;
    }
    redirectToMerchant(token, _cancelUrl);
  }

  useEffect(() => {
    const isVisible = show || isShowTransactionExpiredModal;
    if (!isVisible || !_cancelUrl) return;

    const timerId = setTimeout(redirectToCancelUrl, AUTO_REDIRECT_DELAY_MS);
    return () => clearTimeout(timerId);
  }, [show, isShowTransactionExpiredModal, _cancelUrl]);

  return (
    <Modal
      show={show || isShowTransactionExpiredModal}
      onHide={redirectToCancelUrl}
      centered
      className="cx-transaction-expired-modal"
    >
      <ModalBody>
        <div className="cx-modal-container">
          <div className="cx-modal-wrapper">
            <div className="cx-modal-body-container">
              <div className="cx-modal-body-wrapper txPart">
                <p><strong className="cx-d-block">Transaction expired</strong></p>
                <div className="mb-2">
                  <BiTimer color="#0533B3" size={60} />
                </div>
                {
                  _cancelUrl ?
                    <Button className='px-4' variant="primary" onClick={redirectToCancelUrl}>Ok</Button>
                    : null
                }
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}
